import * as auth from "./auth"
import * as events from "./events"
import * as contacts from "./contacts"
import * as messages from "./messages"
import * as payments from "./payments"

const api = {
  auth,
  events,
  contacts,
  messages,
  payments,
}

export default api
